import { createReducer } from 'reduxsauce'
import { data_store } from 'src/types'

import { data_types } from '../../actions'

/**
 * From product service
 */
export const reduce_formik_pool = (state: data_store, { formik_pool }: data_store): data_store => ({
  ...state,
  formik_pool,
})

export const reduce_metadata = (state: data_store, { metadata }: data_store): data_store => ({
  ...state,
  metadata,
})

export const reduce_products = (state: data_store, { products }: data_store): data_store => ({
  ...state,
  products,
})

export const reduce_vehicle_brands = (
  state: data_store,
  { vehicle_brands }: data_store
): data_store => ({
  ...state,
  vehicle_brands,
})

export const reduce_vehicle_mop_brands = (
  state: data_store,
  { vehicle_mop_brands }: data_store
): data_store => ({
  ...state,
  vehicle_mop_brands,
})

export const reduce_vehicle_models = (
  state: data_store,
  { vehicle_models }: data_store
): data_store => ({
  ...state,
  vehicle_models,
})

export const reduce_vehicle_mop_models = (
  state: data_store,
  { vehicle_mop_models }: data_store
): data_store => ({
  ...state,
  vehicle_mop_models,
})

export const reduce_vehicle_versions = (
  state: data_store,
  { vehicle_versions }: data_store
): data_store => ({
  ...state,
  vehicle_versions,
})

export const reduce_residence_municipalities = (
  state: data_store,
  { residence_municipalities }: data_store
): data_store => ({
  ...state,
  residence_municipalities,
})

export const reduce_agencies = (state: data_store, { agencies }: data_store): data_store => ({
  ...state,
  agencies,
})

export const reduce_quote = (state: data_store, { quote }: data_store): data_store => ({
  ...state,
  quote,
})

export const reduce_quotedoc = (state: data_store, { quotedoc }: data_store): data_store => ({
  ...state,
  quotedoc,
})

export const reduce_otherdocs = (state: data_store, { otherdocs }: data_store): data_store => ({
  ...state,
  otherdocs,
})

export const reduce_otherdoc = (state: data_store, { otherdoc }: data_store): data_store => ({
  ...state,
  otherdoc,
})

// TODO: Rimuovere
export const reduce_municipalities_temp = (
  state: data_store,
  { municipalities_temp }: data_store
): data_store => ({
  ...state,
  municipalities_temp,
})

export const reduce_cookie_informatives = (
  state: data_store,
  { cookie_informatives }: data_store
): data_store => ({
  ...state,
  cookie_informatives,
})

export const reduce_documents = (state: data_store, { documents }: data_store): data_store => ({
  ...state,
  documents,
})

export const reduce_document = (state: data_store, { document }: data_store): data_store => ({
  ...state,
  document,
})

export default createReducer(
  {},
  {
    [data_types.REDUCE_FORMIK_POOL]: reduce_formik_pool,
    [data_types.REDUCE_METADATA]: reduce_metadata,
    [data_types.REDUCE_PRODUCTS]: reduce_products,
    [data_types.REDUCE_VEHICLE_BRANDS]: reduce_vehicle_brands,
    [data_types.REDUCE_VEHICLE_MOP_BRANDS]: reduce_vehicle_mop_brands,
    [data_types.REDUCE_VEHICLE_MODELS]: reduce_vehicle_models,
    [data_types.REDUCE_VEHICLE_VERSIONS]: reduce_vehicle_versions,
    [data_types.REDUCE_RESIDENCE_MUNICIPALITIES]: reduce_residence_municipalities,
    [data_types.REDUCE_AGENCIES]: reduce_agencies,
    [data_types.REDUCE_QUOTE]: reduce_quote,
    [data_types.REDUCE_QUOTEDOC]: reduce_quotedoc,
    [data_types.REDUCE_OTHERDOCS]: reduce_otherdocs,
    [data_types.REDUCE_OTHERDOC]: reduce_otherdoc,
    [data_types.REDUCE_MUNICIPALITIES_TEMP]: reduce_municipalities_temp, // TODO: Rimuovere
    [data_types.REDUCE_COOKIE_INFORMATIVES]: reduce_cookie_informatives,
    [data_types.REDUCE_DOCUMENTS]: reduce_documents,
    [data_types.REDUCE_DOCUMENT]: reduce_document,
  }
)
